import { RouteType } from "../../types/RouteType";
import BOMViewStore from "./MixDesignViewStore";

const MixDesignRoute: RouteType = {
  name: "Mix Design Workflow",
  path: "/mix-design/workflow",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./MixDesignWorkflowHeader"),
      title: "Mix Design Management",
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./MixDesignWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Initialize the BOMViewStore if not already created
    if (!(rootStore as any).bomViewStore) {
      (rootStore as any).bomViewStore = new BOMViewStore(rootStore);
    }

    // Check if productsStore exists before trying to load
    if ((rootStore as any).productsStore) {
      try {
        // Load products (concrete mixes) if not already loaded
        if ((rootStore as any).productsStore.entities.length === 0) {
          await (rootStore as any).productsStore.find({
            query: {
              active: true,
              $limit: 500,
            },
          });
        }
      } catch (error) {
        console.warn("Could not load products:", error);
      }
    }

    // Load mix design items (raw materials) if not already loaded
    if ((rootStore as any).mixDesignItemsStore?.entities.length === 0) {
      await (rootStore as any).mixDesignItemsStore.find({
        query: {
          active: true,
          $limit: 1000,
        },
      });
    }

    // Optionally load existing mix designs
    if ((rootStore as any).mixDesignsStore) {
      await (rootStore as any).mixDesignsStore.find({
        query: {
          active: true,
          $limit: 100,
        },
      });
    }

    return true;
  },
  onParamsChange: async ({ rootStore, params, queryParams }) => {
    // Handle productId if passed as query param
    if (queryParams?.productId && (rootStore as any).bomViewStore) {
      const productId = Number(queryParams.productId);
      if (!isNaN(productId)) {
        (rootStore as any).bomViewStore.setSelectedProduct(productId);
      }
    }
  },
};

export default MixDesignRoute;
